module.exports = __webpack_public_path__ + "src/assets/fonts/217ce3a8978f6faa145e988027489dc6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/217ce3a8978f6faa145e988027489dc6.woff2
// module id = 569
// module chunks = 58